import React, { useRef, useState } from "react";
import Avatar2 from "../../../assets/Avatar7.png";
import { BsDisplay } from "react-icons/bs";
import { FiLogOut } from "react-icons/fi";

function ManagerUserProfilePrivacy() {
  const [formData, setFormData] = useState({
    current: "",
    newPass: "",
    confirm: "",
  });

  return (
    <div className="flex self-stretch justify-start items-start flex-col gap-8 pt-4">
      <div className="flex self-stretch justify-start items-start flex-col gap-6">
        <div className="flex self-stretch justify-start items-start flex-col gap-5">
          {/* password */}
          <div className="flex flex-wrap self-stretch justify-start items-start flex-row gap-y-4 gap-x-8 ">
            <div className="min-w-[200px] max-w-[280px] flex flex-1 justify-start items-start flex-col">
              <div className="flex justify-start items-center flex-row gap-0.5">
                <span className="text-[#414651] text-sm  font-semibold">
                  Password
                </span>
              </div>
              <p className="self-stretch text-[#535862] text-sm ">
                Please enter your current password to change your password.
              </p>
            </div>
            <div className="min-w-[320px] max-w-[720px] flex flex-1 justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
              <div className="flex self-stretch justify-start items-start flex-col gap-6 p-[24px]">
                <form
                  action=""
                  className="w-full flex items-start gap-5 flex-col"
                >
                  <div className="w-full pb-8 border-b border-gray-200 flex items-start ">
                    <label className="text-[#414651] text-sm  font-medium w-1/2">
                      Current password
                      <span className="text-[#009C97] text-sm  font-medium">
                        *
                      </span>
                    </label>
                    <div className="flex flex-col gap-1 w-full">
                      <input
                        type="password"
                        value={formData.current}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            current: e.target.value,
                          }))
                        }
                        className="w-full p-2 rounded-lg border border-gray-200 outline-none text-gray-700"
                      />
                      {formData.current.length > 0 &&
                        formData.current.length < 8 && (
                          <p className="text-red-500 text-xs mt-1">
                            Password must be at least 8 characters.
                          </p>
                        )}
                    </div>
                  </div>

                  {/*  */}
                  <div className="w-full pb-8 border-b border-gray-200 flex items-start ">
                    <label className="text-[#414651] text-sm  font-medium w-1/2">
                      New password
                      <span className="text-[#009C97] text-sm  font-medium">
                        *
                      </span>
                    </label>
                    <div className="flex flex-col gap-1 w-full">
                      <input
                        type="password"
                        value={formData.newPass}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            newPass: e.target.value,
                          }))
                        }
                        className="w-full p-2 rounded-lg border border-gray-200 outline-none text-gray-700"
                      />
                      {formData.newPass.length > 0 &&
                        formData.newPass.length < 8 && (
                          <p className="text-red-500 text-xs mt-1">
                            Password must be at least 8 characters.
                          </p>
                        )}
                    </div>
                  </div>
                  {/*  */}
                  <div className="w-full flex items-start ">
                    <label className="text-[#414651] text-sm  font-medium w-1/2">
                      Confirm new password
                      <span className="text-[#009C97] text-sm  font-medium">
                        *
                      </span>
                    </label>
                    <input
                      type="password"
                      className="w-full p-2 rounded-lg border border-gray-200 outline-none text-gray-700"
                    />
                  </div>
                </form>
              </div>
              <div className="flex self-stretch justify-start items-center flex-col gap-4 pb-4 border-t border-gray-200 pt-4">
                <div className="flex items-center justify-end w-full gap-3 px-6">
                  <button className="bg-[#009C97] text-white rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                    Save changes
                  </button>
                  <button className=" text-gray-700 border border-gray-300 hover:bg-gray-100 transition duration-150 rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                    Cancle
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch bg-[#E9EAEB] h-px"></div>
          {/* logged in */}

          <div className="flex flex-wrap self-stretch justify-start items-start flex-row gap-y-4 gap-x-8 ">
            <div className="min-w-[200px] max-w-[280px] flex flex-1 justify-start items-start flex-col">
              <div className="flex justify-start items-center flex-row gap-0.5">
                <span className="text-[#414651] text-sm  font-semibold">
                  Where you’re logged in
                </span>
              </div>
              <p className="self-stretch text-[#535862] text-sm ">
                We’ll alert you via olivia@untitledui.com if there is any
                unusual activity on your account.
              </p>
            </div>
            <div className="min-w-[320px] p-6 max-w-[720px] flex gap-6 flex-1 justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
              <div className="flex items-start justify-start gap-4 w-full border-b border-gray-200 pb-6">
                <BsDisplay className="w-7 h-7 text-gray-800 " />
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-3">
                    <h2 className="text-sm text-gray-700 font-semibold">
                      2024 MacBook Pro 14-inch
                    </h2>
                    <div className="border border-gray-200 rounded-lg px-2 py-1 flex items-center gap-1.5">
                      <span className="w-2 h-2 rounded-full bg-green-600"></span>
                      <span className="text-gray-600 text-xs font-semibold">
                        Active now
                      </span>
                    </div>
                  </div>
                  <p className="flex max-[420px]:flex-col max-[420px]:items-start items-center gap-2 text-gray-700">
                    <span className="text-sm text-gray-700 font-normal">
                      Melbourne, Australia
                    </span>
                    <span className="max-[420px]:hidden"> &bull;</span>
                    <span className="text-sm text-gray-700 font-normal">
                      22 Jan at 10:40am
                    </span>
                  </p>
                </div>
              </div>
              {/*  */}

              <div className="flex items-center justify-between w-full  ">
                <div className="flex items-start justify-start gap-4 w-2/3 ">
                  <BsDisplay className="w-7 h-7 text-gray-800 " />
                  <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-3">
                      <h2 className="text-sm text-gray-700 font-semibold">
                        2024 MacBook Pro 14-inch
                      </h2>
                    </div>
                    <p className="flex max-[420px]:flex-col max-[420px]:items-start items-center gap-2 text-gray-700">
                      <span className="text-sm text-gray-700 font-normal">
                        Melbourne, Australia
                      </span>
                      <span className="max-[420px]:hidden"> &bull;</span>
                      <span className="text-sm text-gray-700 font-normal">
                        22 Jan at 10:40am
                      </span>
                    </p>
                  </div>
                </div>

                <button className="text-red-600 flex items-center gap-2 cursor-pointer font-semibold text-sm px-3">
                  <FiLogOut className="w-5 h-6" />
                  Sign out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManagerUserProfilePrivacy;
